import motorPrivateModule from './motor/Motor_private/MotorPrivateStore';
import motorCommercialModule from './motor/Motor_Commercial/MotorCommercialStore';
import productsData from './products';
import InsuranceModelData from './insurance.model';
import { saveState, loadState } from '../../libs/persist';

const persistedState = loadState('insuranceRootState') || {};

export default {
	namespaced: true,
	state: () => ({
		products: productsData,
		currentStep: persistedState.currentStep || 'category',
		selectedCategory: persistedState.selectedCategory || null,
		selectedProduct: null,
		loading: false,
	}),
	getters: {
		InsuranceModel: (state) => InsuranceModelData,
		filteredProducts: (state) => {
			if (!state.selectedCategory) return [];
			return state.products[state.selectedCategory] || [];
		},
		getProductById: (state) => (id) => {
			const allProducts = [
				...state.products.individual,
				...state.products.business,
				...state.products.other,
			];
			return allProducts.find((product) => product.id === parseInt(id));
		},
		getProductByClassCode: (state) => (classCode) => {
			const allProducts = [
				...state.products.individual,
				...state.products.business,
				...state.products.other,
			];
			return allProducts.find(
				(product) => product.classCode === classCode,
			);
		},
		currentStep: (state) => state.currentStep,
		selectedCategory: (state) => state.selectedCategory,
		loading: (state) => state.loading,
	},
	mutations: {
		resetInsuranceFlow(state) {
			state.currentStep = 'category';
			state.selectedCategory = null;
			state.selectedProduct = null;
			saveState('insuranceRootState', {
				currentStep: state.currentStep,
				selectedCategory: state.selectedCategory,
			});
		},
		setSelectedProduct(state, product) {
			state.selectedProduct = product;
		},
		products(state, payload) {
			state.products = payload;
		},
		currentStep(state, payload) {
			state.currentStep = payload;
			saveState('insuranceRootState', {
				currentStep: state.currentStep,
				selectedCategory: state.selectedCategory,
			});
		},
		selectedCategory(state, payload) {
			state.selectedCategory = payload;
			saveState('insuranceRootState', {
				currentStep: state.currentStep,
				selectedCategory: state.selectedCategory,
			});
		},
		loading(state, payload) {
			state.loading = payload;
		},
	},
	actions: {
		setCategory({ commit }, category) {
			commit('loading', true);
			setTimeout(() => {
				commit('selectedCategory', category);
				commit('currentStep', 'product');
				commit('loading', false);
			}, 500);
		},
		setProduct({ commit }, product) {
			commit('setSelectedProduct', product);
		},
		goBack({ commit, state }) {
			if (state.currentStep === 'product') {
				commit('currentStep', 'category');
				commit('selectedCategory', null);
			}
		},
		selectProductForRoute({ commit }, productData) {
			commit('setSelectedProduct', productData);
			return Promise.resolve(productData);
		},
	},
	modules: {
		motorPrivate: motorPrivateModule,
		motorCommercial: motorCommercialModule,
	},
};
